export const benefitItems = ["item-one", "item-two", "item-three"]

type BenefitItem = {
  title: string
  description: string
}

export type Benefits = {
  title: string
  "item-one": BenefitItem
  "item-two": BenefitItem
  "item-three": BenefitItem
}
